import analyticsWrapper from './analyticsWrapper';

const ERROR_PERFORMANCE_MARK = 'Error reading performance mark';

const startedBundleFetch = (orderId: string) => {
  performance.mark('scan_startFetchBundles');
  analyticsWrapper.event({
    category: 'Hub Scan',
    action: 'order scanned',
    label: `Order ${orderId}`,
  });
};

const completedBundleFetch = (orderId: string) => {
  try {
    performance.measure('scan_bundlesFetched', 'scan_startFetchBundles');
    analyticsWrapper.timing({
      category: 'Hub Scan',
      variable: 'bundleFetch',
      label: `Fetched bundles for order ${orderId}`,
      value: performance.getEntriesByName('scan_bundlesFetched')[0].duration,
    });
  } catch (e) {
    console.warn(ERROR_PERFORMANCE_MARK, e);
  } finally {
    performance.clearMarks('scan_startFetchBundles');
    performance.clearMeasures('scan_bundlesFetched');
  }
};

const startedFilteringBundles = () => {
  performance.mark('scan_filterBundles');
};

const completedFilteringBundles = () => {
  try {
    performance.measure('scan_bundlesFiltered', 'scan_filterBundles');
    analyticsWrapper.timing({
      category: 'Hub Scan',
      variable: 'Bundle filtering',
      label: 'Filtered bundles for active one',
      value: performance.getEntriesByName('scan_bundlesFiltered')[0].duration,
    });
  } catch (e) {
    console.warn(ERROR_PERFORMANCE_MARK, e);
  } finally {
    performance.clearMarks('scan_filterBundles');
    performance.clearMeasures('scan_bundlesFiltered');
  }
};

const startedConfirmShelf = (shelfId: string) => {
  performance.mark('scan_startConfirmShelf');
  analyticsWrapper.event({
    category: 'Hub Scan',
    action: 'shelf scanned',
    label: `Shelf ${shelfId}`,
  });
};

const completedConfirmShelf = (shelfId: string) => {
  try {
    performance.measure('scan_shelfConfirmed', 'scan_startConfirmShelf');
    analyticsWrapper.timing({
      category: 'Hub Scan',
      variable: 'confirmShelf',
      label: `Confirmed shelf ${shelfId}`,
      value: performance.getEntriesByName('scan_shelfConfirmed')[0].duration,
    });
  } catch (e) {
    console.warn(ERROR_PERFORMANCE_MARK, e);
  } finally {
    performance.clearMarks('scan_startConfirmShelf');
    performance.clearMeasures('scan_shelfConfirmed');
  }
};

const exportedObject = {
  startedBundleFetch,
  completedBundleFetch,
  startedConfirmShelf,
  completedConfirmShelf,
  startedFilteringBundles,
  completedFilteringBundles,
};

export default exportedObject;
